import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { getStationsPriceReportTimeSlots } from '../operations/getStationsPriceReportTimeSlots';

import { STATUS_LOADING } from 'common/constants';

export const setStationsPriceReportTimeSlots = (
  builder: ActionReducerMapBuilder<StationsState>
) => builder
  .addCase(getStationsPriceReportTimeSlots.pending, (state) => {
    state.stationsPricesReportTimeSlots.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getStationsPriceReportTimeSlots.fulfilled, (state, { payload }) => {
    state.stationsPricesReportTimeSlots.loadingStatus = STATUS_LOADING.done;
    state.stationsPricesReportTimeSlots.data = payload;
  })
  .addCase(getStationsPriceReportTimeSlots.rejected, (state) => {
    state.stationsPricesReportTimeSlots.loadingStatus = STATUS_LOADING.error;
  });
